module.exports = __webpack_public_path__ + "img/credit-icon-1.42383762.svg";